import { render } from "./WaitingList.vue?vue&type=template&id=cc58ec20"
import script from "./WaitingList.vue?vue&type=script&setup=true&lang=js"
export * from "./WaitingList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/WaitingList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cc58ec20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cc58ec20', __exports__)) {
    api.reload('cc58ec20', __exports__)
  }
  
  module.hot.accept("./WaitingList.vue?vue&type=template&id=cc58ec20", () => {
    api.rerender('cc58ec20', render)
  })

}


export default __exports__